import "web/entrypoints/common/polyfills";

import baustein from "baustein";
import { renderReact } from "hypernova-react";
import jinjaToJs from "jinja-to-js";
import analytics from "web/script/analytics/analytics";
import { installJinjaFilters } from "web/script/modules/jinja-filters";
import { installJinjaGlobals } from "web/script/modules/jinja-globals";
import userProfiler from "web/script/modules/userprofiler";
import alerts from "web/script/utils/alerts";
import browser from "web/script/utils/browser";
import history from "web/script/utils/history";
import loadFonts from "web/script/utils/load-fonts";

import "./baustein-common";
import "./css-common";
import commonComponents from "./react-common";

export interface ReactComponentManifest {
    [name: string]: React.ComponentType<any>;
}

export function setup(components: ReactComponentManifest): void {
    loadFonts();
    installJinjaFilters(jinjaToJs);
    installJinjaGlobals(jinjaToJs);

    analytics.init();
    userProfiler.init();
    browser.init();
    alerts.init();
    baustein.init();

    history.start();

    analytics.pageView();

    for (let [name, component] of Object.entries({
        ...commonComponents,
        ...components,
    })) {
        renderReact(name, component);
    }
    // we expose this as a global so 3rd parties can interact with our analytics
    window["lystAnalytics"] = {
        event: analytics.event.bind(analytics),
    };
}
